import type { Router } from 'vue-router'
import { menu } from '@/stores'
import pina from '@/stores/index'
import { setRouteChange } from '/@/logics/mitt/routeChange'

const store = menu(pina)

export function setupRouterGuard(_router: Router) {
  createPageGuard(_router)
  store.buildRoutesAction()
}

/**
 * 处理标签页钩子
 */
function createPageGuard(router: Router) {
  // console.log(router)

  const loadedPageMap = new Map<string, boolean>()

  router.beforeEach(async (to) => {
    // 页面已加载，再次打开它会更快，您不需要进行加载和其他处理
    to.meta.loaded = !!loadedPageMap.get(to.path)
    // 通知路由更改
    setRouteChange(to)

    return true
  })

  router.afterEach((to) => {
    loadedPageMap.set(to.path, true)
  })
}
